import { render, staticRenderFns } from "./SalaryCreditCardComponent.vue?vue&type=template&id=63af9c6d&scoped=true"
import script from "./SalaryCreditCardComponent.vue?vue&type=script&lang=js"
export * from "./SalaryCreditCardComponent.vue?vue&type=script&lang=js"
import style0 from "./SalaryCreditCardComponent.vue?vue&type=style&index=0&id=63af9c6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63af9c6d",
  null
  
)

export default component.exports